<template>
    <div class="section">
        <div class="mobile-advacne-filter">
            <div class="columns columns-top">
                <div class="column">
                    <div class="card">
                        <header class="card-header filter-header" @click="expandCardBody">
                            <div class="card-header-title advance-filter-title advance-search-title">
                                Search
                                <div class="advance-search-icon"><i class="fas fa-search"></i></div>
                            </div>
                            <a class="card-header-icon" aria-label="more options">
                            <span class="icon" v-if="!expanded">
                               <i class="fas fa-angle-down" aria-hidden="true"></i>
                            </span>
                                <span class="icon" v-if="expanded">
                               <i class="fas fa-angle-up" aria-hidden="true"></i>
                            </span>
                            </a>
                        </header>
                        <div class="card-content mobile" v-if="expanded">
                            <div class="content">
                                <div class="columns">

                                    <div class="column is-narrow">
                                        <brand-stock-car></brand-stock-car>
                                    </div>
                                    <div class="column is-narrow">
                                        <model-stock-car></model-stock-car>
                                    </div>
                                    <div class="column is-narrow">
                                        <chassis-stock-car></chassis-stock-car>
                                    </div>
                                    <div class="column small-column advance-search-form">
                                        <year-stock-cars></year-stock-cars>
                                        <mileage-stock-car></mileage-stock-car>
                                        <lot-number-input-stock-car></lot-number-input-stock-car>

                                        <displacement-range-slider-stock v-if="isMobile"></displacement-range-slider-stock>
                                        <transmissions-specification-stock v-if="isMobile"></transmissions-specification-stock>
                                        <search-stock-car></search-stock-car>
                                    </div>
                                  <!--  <div class="column small-column upcoming-past-result">
                                        <auction-type-stock-car></auction-type-stock-car>
                                        <days-stock></days-stock>
                                        <search-stock-car></search-stock-car>
                                    </div>-->
                                </div>
                                <div class="columns columns-specific">
                                    <div class="column column-specific">
                                        <specific-filter-stock-car></specific-filter-stock-car>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns advance-tags">
                <div class="column">
                    <search-query-stock></search-query-stock>
                </div>
            </div>
            <stock-cars-list></stock-cars-list>

        </div>
    </div>
</template>

<script>

    import Chassis from '../Auctions/Advance/Inputs/Chassis.vue'
    import Year from '../Auctions/Advance/Inputs/Year.vue'
    import Mileage from '../Auctions/Advance/Inputs/Mileage.vue'
    import Search from '../Auctions/Advance/Inputs/Search.vue'
    import AuctionType from '../Auctions/Advance/Inputs/AuctionType.vue'
    import Days from '../Auctions/Advance/Inputs/Days.vue'
    import StockCarsList from './StockCarsList.vue'
    import SpecificFilter from '../Auctions/Advance/Specific/SpecificFilter.vue'
    //import PastAuctionTable from './PastAuctions/PastAuctionTable.vue'
    import SearchQuery from '../Auctions/Advance/Result/SearchQuery.vue'
    import LotNumberInput from '../Auctions/Advance/Inputs/LotNumberInput.vue'
    import BrandStockCar from "./BrandStockCar";
    import ModelStockCar from "./ModelStockCar";
    import ChassisStockCar from "./ChassisStockCar";
    import YearStockCars from "./YearStockCars";
    import MileageStockCar from "./MileageStockCar";
    import LotNumberInputStockCar from "./LotNumberInputStockCar";
    import AuctionTypeStockCar from "./AuctionTypeStockCar";
    import DaysStock from "./DaysStock";
    import SearchStockCar from "./SearchStockCar";
    import SpecificFilterStockCar from "./SpecificFilterStockCar";
    import SearchQueryStock from "./SearchQueryStock";
    import DisplacementRangeSliderStock from "./DisplacementRangeSliderStock";
    import TransmissionsSpecificationStock from "./TransmissionsSpecificationStock";

    export default {
        components: {
            SearchQueryStock,
            SpecificFilterStockCar,
            SearchStockCar,
            DaysStock,
            AuctionTypeStockCar,
            LotNumberInputStockCar,
            MileageStockCar,
            YearStockCars,
            ChassisStockCar,
            ModelStockCar,
            BrandStockCar,
            //AuctionNavigation,
            //Brand,
            //Model,
            //Chassis,
            //Year,
            //Mileage,
            Search,
            StockCarsList,
            AuctionType,
            //Days,
            SpecificFilter,
            //PastAuctionTable,
            SearchQuery,
            LotNumberInput,
            DisplacementRangeSliderStock,
            TransmissionsSpecificationStock,
        },
        data() {
            return {
                expanded: (document.documentElement.clientWidth) < 450 ? false : true
            }
        },
        methods: {
            expandCardBody() {
                this.expanded = !this.expanded
            },
            resetBrandModelAndChassis() {
                this.$store.dispatch('setChassisToDefault')
                this.$store.dispatch('setBrandModelToDefault')
            }
        },
        computed: {
            showSelectedBrandModelForMobile() {
                if (document.documentElement.clientWidth < 450) {
                    if (this.$store.getters.getAuctionSearchQuery["brand"].length > 0) {
                        return this.$store.getters.getQueryModels.length > 0
                    }
                }
                return false
            },
            getSelectedModel() {
                return this.$store.getters.getQueryModels[0]
            },
            getSelectedBrand() {
                return this.$store.getters.getAuctionSearchQuery["brand"]
            },
            statsStatus() {
                return this.$store.getters.getStatsStatus
            },
            showBrand() {
                if (document.documentElement.clientWidth > 450) {
                    return true
                } else {
                    return this.$store.getters.getAuctionSearchQuery["brand"].length === 0
                }
            },
            showModel() {
                if (document.documentElement.clientWidth > 450) {
                    return true
                } else {
                    return this.$store.getters.getAuctionSearchQuery["brand"].length > 0
                        && this.$store.getters.getQueryModels.length === 0
                }
            },
            showChassis() {
                if (document.documentElement.clientWidth > 450) {
                    return true
                } else {
                    return this.$store.getters.getQueryModels.length > 0
                }
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        },
        mounted() {
            this.$store.dispatch('fetchBrandsFromServer');
        }
    }
</script>

<style scoped>
    .column {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 5px;
    }

    .column-specific {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .columns-top {
        padding-top: 13px;
    }

    .small-column {
        max-width: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/StockCars.vue